// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const sagaHubPeerSchema = z.object({
  id: z.string().max(200),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  peerHubUrl: z.string().max(500),
  peerHubId: z.string().max(200),
  peerWalletAddress: z.string().max(200),
  peerPublicKey: z.string().max(500).optional(),
  federationAgreementId: z.string().max(200).optional(),
  status: z.enum(['active', 'suspended', 'pending']).default('pending'),
  lastReplicationAt: z.string().max(200).datetime().optional(),
  sharedAgentCount: z.number().int().min(0).default(0),
  replicationConfig: z.object({
    collections: z.array(z.string()),
    pollingIntervalMs: z.number().int().min(1000),
    batchSize: z.number().int().min(1).max(1000),
  }).optional(),

  registeredAt: z.string().max(200).datetime(),
})

export type SagaHubPeerInput = z.infer<typeof sagaHubPeerSchema>
